import type { IconComponentBaseProps } from 'components/atoms/Icon/types';

import { defaultTheme } from '@/theme';

type PinInvokeProps = IconComponentBaseProps;

export const PinInvoke = ({
  className,
  width = 24,
  height = 24,
  fill = defaultTheme.mantineColors.gray[7],
}: PinInvokeProps) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
    >
      <mask
        id="mask0_10258_35936"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_10258_35936)">
        <path
          d="M4.30775 19.5C3.80258 19.5 3.375 19.325 3.025 18.975C2.675 18.625 2.5 18.1974 2.5 17.6923V6.30775C2.5 5.80258 2.675 5.375 3.025 5.025C3.375 4.675 3.80258 4.5 4.30775 4.5H13.1155C13.328 4.5 13.5061 4.57192 13.6497 4.71575C13.7934 4.85958 13.8652 5.03775 13.8652 5.25025C13.8652 5.46292 13.7934 5.641 13.6497 5.7845C13.5061 5.92817 13.328 6 13.1155 6H4.30775C4.23075 6 4.16025 6.03208 4.09625 6.09625C4.03208 6.16025 4 6.23075 4 6.30775V17.6923C4 17.7692 4.03208 17.8398 4.09625 17.9038C4.16025 17.9679 4.23075 18 4.30775 18H19.6923C19.7693 18 19.8398 17.9679 19.9038 17.9038C19.9679 17.8398 20 17.7692 20 17.6923V12.8845C20 12.672 20.0719 12.4939 20.2157 12.3503C20.3596 12.2066 20.5378 12.1348 20.7502 12.1348C20.9629 12.1348 21.141 12.2066 21.2845 12.3503C21.4282 12.4939 21.5 12.672 21.5 12.8845V17.6923C21.5 18.1974 21.325 18.625 20.975 18.975C20.625 19.325 20.1974 19.5 19.6923 19.5H4.30775ZM13.25 12.8095L10.221 15.8385C10.0723 15.9872 9.89833 16.0606 9.699 16.0588C9.49967 16.0568 9.32175 15.9782 9.16525 15.823C9.02175 15.668 8.94742 15.4924 8.94225 15.2963C8.93708 15.1001 9.01208 14.9244 9.16725 14.7692L12.2058 11.7402H10.35C10.1375 11.7402 9.95942 11.6684 9.81575 11.5247C9.67192 11.3809 9.6 11.2027 9.6 10.99C9.6 10.7775 9.67192 10.5994 9.81575 10.4557C9.95942 10.3122 10.1375 10.2405 10.35 10.2405H13.8462C14.1022 10.2405 14.3169 10.3271 14.4902 10.5003C14.6634 10.6734 14.75 10.8881 14.75 11.1443V14.6405C14.75 14.853 14.6781 15.0311 14.5343 15.1748C14.3904 15.3184 14.2122 15.3903 13.9998 15.3903C13.7871 15.3903 13.609 15.3184 13.4655 15.1748C13.3218 15.0311 13.25 14.853 13.25 14.6405V12.8095ZM18.7885 9.923C18.0353 9.923 17.3951 9.65942 16.8678 9.13225C16.3406 8.60492 16.077 7.96467 16.077 7.2115C16.077 6.45833 16.3406 5.81817 16.8678 5.291C17.3951 4.76367 18.0353 4.5 18.7885 4.5C19.5417 4.5 20.1818 4.76367 20.709 5.291C21.2363 5.81817 21.5 6.45833 21.5 7.2115C21.5 7.96467 21.2363 8.60492 20.709 9.13225C20.1818 9.65942 19.5417 9.923 18.7885 9.923Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};
